import { render, staticRenderFns } from "./PDFContainer.vue?vue&type=template&id=b3f8a4d4"
import script from "./PDFContainer.vue?vue&type=script&lang=js"
export * from "./PDFContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports